import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListInventoryComponent } from './pages/list-inventory/list-inventory.component';
import { FormComponent } from './pages/form/form.component';
import { SearchComponent } from './pages/search/search.component';
import { SharedModule } from '@app/shared/shared.module';
import { httpInterceptorProviders } from '@app/auth/interceptors';



@NgModule({
  declarations: [ListInventoryComponent, FormComponent, SearchComponent],
  imports: [CommonModule, SharedModule],
  providers: [httpInterceptorProviders],
})
export class InventoryModule { }
